import { useState, useEffect } from "react";
import Select, { components } from "react-select";
import { useFormikContext } from "formik";
import { useLocation, createSearchParams } from "react-router-dom";
import { getSessionObjectId } from "../../CommonFuntion/indexHelper";

const InputOption = ({
  getStyles,
  Icon,
  isDisabled,
  isFocused,
  isSelected,
  children,
  innerProps,
  ...rest
}) => {
  const [isActive, setIsActive] = useState(false);
  const onMouseDown = () => setIsActive(true);
  const onMouseUp = () => setIsActive(false);
  const onMouseLeave = () => setIsActive(false);

  // styles
  let bg = "transparent";
  if (isFocused) bg = "#eee";
  if (isActive) bg = "#B2D4FF";

  const style = {
    alignItems: "center",
    backgroundColor: bg,
    color: "inherit",
    display: "flex ",
  };

  // prop assignment
  const props = {
    ...innerProps,
    onMouseDown,
    onMouseUp,
    onMouseLeave,
    style,
  };

  return (
    <components.Option
      {...rest}
      isDisabled={isDisabled}
      isFocused={isFocused}
      isSelected={isSelected}
      getStyles={getStyles}
      innerProps={props}
    >
      <input type="checkbox" checked={isSelected} onChange={(e) => {}} />
      {children}
    </components.Option>
  );
};

export default function MultiSelect(props) {

  let location = useLocation();
  const searchParams = createSearchParams(location.search);
  const [selectedOptions, setSelectedOptions] = useState([]);

  useEffect(() => {
    const localStorageData = localStorage.getItem(
      user_id +
        getSessionObjectId(searchParams) +
        "multiSelectLabelItem"
    );

    const imageData = localStorageData ? JSON.parse(localStorageData) : null;

    if (imageData) {
      const optionsArray = imageData ? imageData["options"] : [];
      setSelectedOptions(optionsArray);
    }
  }, [location.search.toString()]); 

  const { setFieldValue, values } = useFormikContext();
  const { name, label, options, value, tagName, prefix, validation, showImage,user_id } = props;

  const onDropdownChange = (optn) => {
    if (optn) {
      setFieldValue([name], optn);
    }
  };
  return (
    <div className="flex-container">
      <div className="control-bottom-border">
        {label && (
          <label className="font-css">
            {label.replace("_", " ")}

            {validation?.mandatory && (
              <span className="mandatory-validation">{"*"}</span>
            )}
          </label>
        )}
      </div>
      <div className="control-bottom-border font-css ">
        <Select
          value={selectedOptions}
          id={tagName}
          name={name}
          key={name}
          tagname={tagName}
          fieldname={name}
          prefix={prefix}
          isMulti
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          onChange={(options) => {
            if (Array.isArray(options)) {
              setSelectedOptions(options);

              onDropdownChange(options.map((opt) => opt.label));

              localStorage.setItem(
                user_id +
                  getSessionObjectId(searchParams) +
                  "multiSelectLabelItem",
                JSON.stringify({ options })
              );
            }
          }}
          options={options}
          components={{
            Option: InputOption,
          }}
        />
      </div>
      { showImage && selectedOptions.map((element, index) => (
        <div key={index} className="image-card">
          <div className="font-css">{element.imageId}</div>
          <img
            key={index}
            src={
              process.env.REACT_APP_SITE_URL +
              `/Pages/Utils/ShowImage.ashx?Category=${element.imageCategoryId}&ImageID=${element.imageId}`
            }
            alt={`Image ${index}`}
          />
        </div>
      ))}
    </div>
  );
}
